<a
  class="c-list-section__anchor"
  [style.top.px]="sectionAnchorTopOffset"
  [id]="section.id"
></a>
<ng-container [ngSwitch]="sectionHeadingLevel">
  <h2
    *ngSwitchCase="2"
    class="qa-section-title fw-light fs-3 text-dark u-m0"
    id="section_{{ section.id }}"
  >
    {{ section.title }}
  </h2>
  <h3
    *ngSwitchCase="3"
    class="qa-section-title fw-light fs-3 text-dark u-m0"
    id="section_{{ section.id }}"
  >
    {{ section.title }}
  </h3>
  <h4
    *ngSwitchCase="4"
    class="qa-section-title fw-light fs-3 text-dark u-m0"
    id="section_{{ section.id }}"
  >
    {{ section.title }}
  </h4>
  <h5
    *ngSwitchCase="5"
    class="qa-section-title fw-light fs-3 text-dark u-m0"
    id="section_{{ section.id }}"
  >
    {{ section.title }}
  </h5>
  <h6
    *ngSwitchCase="6"
    class="qa-section-title fw-light fs-3 text-dark u-m0"
    id="section_{{ section.id }}"
  >
    {{ section.title }}
  </h6>
  <div
    *ngSwitchDefault
    class="qa-section-title fw-light fs-3 text-dark u-m0"
    role="heading"
    [attr.aria-level]="sectionHeadingLevel"
  >
    {{ section.title }}
  </div>
</ng-container>
<p *ngIf="section.description" class="u-m0">{{ section.description }}</p>
